define(['jquery', 'globalVars'], ($, { $body, $html }) => {
    return {
        settings: {
            $menuIcon: $('#menuToggle'),
            $navigation: $('.nav-sections'),
            navigationItem: '.js-menu-nav-item',
            $navigationItemLevel0: $('.js-menu-nav-item').filter('.level0'),
            navigationLink: '.js-menu-nav-link',
            navigationDescription: '.js-menu-nav-description',
            classMenuOpen: '_menu-open',
            classOpen: '_open',
            classSubmenu: '_submenu',
            classSubmenuL1: '_submenu-level-1',
            classSubmenuL2: '_submenu-level-2',
            classActive: '_active',
            classItemL1: 'level1',
            classItemL2: 'level2',
            $activeTitle: null,
            $activeItem: null,
        },

        init() {
            this.bindEvents();
        },

        bindEvents() {
            this.settings.$menuIcon.on('click', this.toggleMenu.bind(this));
            $body.on('click', '.js-submenu-back', this.closeSubmenu.bind(this));
            $body.on(
                'click',
                this.settings.navigationLink,
                this.clickMenuLink.bind(this)
            );
            $body.on('tap', '.js-menu-overlay', this._closeMenu.bind(this));
            this.settings.$navigationItemLevel0.on(
                'click',
                this.loadImages.bind(this)
            );
        },

        toggleMenu(ev) {
            ev.preventDefault();

            if ($html.hasClass('_search-open')) {
                return;
            }

            $html.hasClass(this.settings.classMenuOpen)
                ? this._closeMenu()
                : this._openMenu();
        },

        _openMenu() {
            $html.addClass(this.settings.classMenuOpen);
        },

        _closeMenu(ev) {
            ev && ev.preventDefault();

            $html.removeClass(this.settings.classMenuOpen);
        },

        loadImages(ev) {
            const $target = $(ev.currentTarget);
            const $images = $target.find('.js-lazy');

            $images.each((index, el) => {
                $(el)
                    .attr('src', $(el).data('lazy-src'))
                    .removeClass('js-lazy');
            });
        },

        clickMenuLink(ev) {
            const $this = $(ev.currentTarget);

            if ($this.hasClass(this.settings.classActive)) {
                return;
            }

            ev.preventDefault();

            this.openSubmenu(ev, $this);
        },

        openSubmenu(ev, $this) {
            ev.preventDefault();

            const $parent = $this.closest(this.settings.navigationItem);

            if ($this.hasClass('_sub')) {
                const $closeParent = $this.closest('.js-menu-nav-item.level0');
                const $description = $closeParent.find(
                    this.settings.navigationDescription
                );

                $closeParent.find('.js-submenu-static').show();
                $description.length &&
                    $description.addClass(this.settings.classActive);
            }

            $this.addClass(this.settings.classActive);
            $parent.addClass(this.settings.classOpen);
            this.settings.$navigation.addClass(this.settings.classSubmenu);
            this.settings.$activeTitle = $this;
            this.settings.$activeItem = $parent;

            if ($parent.hasClass(this.settings.classItemL1)) {
                this.settings.$navigation.addClass(
                    this.settings.classSubmenuL1
                );
            }

            if ($parent.hasClass(this.settings.classItemL2)) {
                this.settings.$navigation.addClass(
                    this.settings.classSubmenuL2
                );
            }
        },

        closeSubmenu(ev) {
            ev.preventDefault();

            const parentItemLevel1 = this.settings.$activeItem.closest(
                '.js-menu-nav-item.level1'
            );
            const parentLinksLevel1 = parentItemLevel1.find(
                '.js-menu-nav-link.level1'
            );

            this.settings.$activeTitle.removeClass(this.settings.classActive);
            this.settings.$activeItem.removeClass(this.settings.classOpen);

            if (this.settings.$activeItem.hasClass(this.settings.classItemL2)) {
                this.settings.$navigation.removeClass(
                    this.settings.classSubmenuL2
                );

                this.settings.$activeTitle = parentLinksLevel1.filter(
                    `.${this.settings.classActive}`
                );
                this.settings.$activeItem = parentItemLevel1.filter(
                    `.${this.settings.classOpen}`
                );

                return;
            }

            if (this.settings.$activeItem.hasClass(this.settings.classItemL1)) {
                this.settings.$navigation.removeClass(
                    this.settings.classSubmenuL1
                );
                this.settings.$activeTitle = $(
                    this.settings.navigationLink
                ).filter(`.${this.settings.classActive}`);
                this.settings.$activeItem = $(
                    this.settings.navigationItem
                ).filter(`.${this.settings.classOpen}`);

                this.settings.$activeItem.find('.js-submenu-static').hide();
                this.settings.$activeItem.find('.js-submenu-column-img').hide();
                this.settings.$activeItem
                    .find(this.settings.navigationDescription)
                    .removeClass(this.settings.classActive);

                return;
            }

            this.settings.$navigation.removeClass(this.settings.classSubmenu);
        },
    };
});
